import * as React from "react";
import { toast } from "react-toastify";
import { RenameDialog } from "@/components/modals/RenameDialog";
import { useRenameConversationMutation } from "../api";
import { RecentQAConversation } from "../types";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  conversation: RecentQAConversation;
}

export const RenameConversationModal: React.FC<Props> = ({ isOpen, setIsOpen, conversation }) => {
  const [renameConversation] = useRenameConversationMutation();

  return (
    <RenameDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Rename conversation"
      placeholder="Enter conversation name"
      initialName={conversation.name ?? conversation.last_message ?? ""}
      successMessage="Conversation renamed"
      onRename={async name => {
        await renameConversation({ conversation_id: conversation.conversation_id, name }).unwrap();
      }}
      onError={() => toast.error("Failed to rename conversation")}
    />
  );
};
